import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import UserModel from '@/models/user';
import MeetingModal from '@/models/meeting';
import Chat from '@/models/chat';
import RTCInstance from '@/models/rtc';
import s from './index.less';
import { useSize } from 'ahooks';
import Barrage from '@/models/barrage';
import LanguageSelect from './components/LanguageSelect';
import HoverIcon from './components/HoverIcon';
import { useBarrage } from '../../hooks/useBarrage/use-barrage';
import BarrageList from './components/BarrageList';
import FontSlider from './components/FontSlider';
import { useBarrageList } from '../../hooks/useBarrage/use-barrage-list';
import LoadingTip from './components/LoadingTip';
import { useLanguage } from '../../hooks/useBarrage/use-language';
import ConnectError from './components/ConnectError';
import { Lang } from '@/types/lang';
interface BarragePanelProps {
  visible: boolean;
  meeting?: MeetingModal;
  chat?: Chat;
  user?: UserModel;
  rtc?: RTCInstance;
  barrage?: Barrage;
}

const BarragePanel: React.FC<BarragePanelProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    user: store.user,
    chat: store.chat,
    rtc: store.rtc,
    barrage: store.barrage,
  };
})(
  observer((props: BarragePanelProps) => {
    const { barrage, meeting } = props;
    const minHeight = 160;
    const { formatMessage } = useIntl();
    const $i = (mid: string) => {
      return formatMessage({ id: mid });
    };
    const [mvHeight, setMvHeight] = useState<any>();
    const initBottom = useRef<any>(null);
    const dragRef = useRef<any>(null);
    const size = useSize(() => document.body);

    const dragImg = new Image(0, 0);
    dragImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    const { originLang, targetLang } = useLanguage();

    // const handleDrag = (event: any, info: any) => {
    //   const mvHeight = initBottom.current - info.point.y;
    //   const maxMvheight = Math.min((size?.height - 168) / 2 - 160, size?.height - 168 - 200 - 160);
    //   console.log('字幕--info.point', info.point);
    //   console.log('字幕--initBottom.current', initBottom.current);
    //   console.log('字幕--maxMvheight', maxMvheight);
    //   if (info.point.y && mvHeight < maxMvheight && mvHeight > 0) {
    //     setMvHeight(mvHeight);
    //     barrage?.setMvHeight(mvHeight);
    //   }
    // };

    const stompMsgToBarrageMsg = (stmopMsg: any) => {
      const member = meeting?.getMemberByYxuid(`${stmopMsg.sentences?.[0]?.speakerYxUid}`);
      return {
        timestamp: stmopMsg.timestamp,
        subtitleContent: stmopMsg.sentences?.[0]?.sentence || '',
        id: stmopMsg.sentences?.[0]?.speakerYxUid + stmopMsg.timestamp.toString(),
        name: member?.memberName,
        url: '',
        yxuid: stmopMsg.sentences?.[0]?.speakerYxUid,
        sentenceType: stmopMsg.sentences?.[0]?.sentenceType,
        uid: stmopMsg.sentences?.[0]?.speakerMemberUid,
      };
    };

    useEffect(() => {
      setTimeout(() => {
        initBottom.current = dragRef.current?.getBoundingClientRect()?.bottom;
      }, 20);
    }, [barrage?.barrageVisible]);

    React.useEffect(() => {
      const resizeHandle = () => {
        setTimeout(() => {
          initBottom.current = document.body.clientHeight - 84 - 160;
        }, 20);
        const maxMvheight = Math.min(
          (document.body.clientHeight - 168) / 2 - 160,
          document.body.clientHeight - 168 - 200 - 160
        );

        if (mvHeight > maxMvheight && maxMvheight > 0) {
          setMvHeight(maxMvheight);
          barrage?.setMvHeight(maxMvheight);
        }
      };
      window.addEventListener('resize', resizeHandle);
      return () => {
        window.removeEventListener('resize', resizeHandle);
      };
    }, [mvHeight]);

    const onLanguageChange = (data: { originLang: Lang; targetLang: Lang }) => {
      barrage?.setOriginLang(data.originLang, true);
      barrage?.setTargetLang(data.targetLang, true);
    };

    const handleCloseBarrage = () => {
      barrage?.setBarrageVisible(false);
      setMvHeight(0);
    };
    const { resMsg, connect, connected, connectError } = useBarrage();

    const onSizeChange = (value: number) => {
      barrage?.setBarrageFontSize(value);
    };

    const { barrageList, pushRecord, clearRecord, setHasNewBarrage } = useBarrageList();

    useEffect(() => {
      if (resMsg) {
        const msg = stompMsgToBarrageMsg(resMsg);
        setHasNewBarrage(true);
        pushRecord(msg);
      }
    }, [resMsg]);

    useEffect(() => {
      if (barrage?.barrageVisible) {
        connect(true);
      } else {
        clearRecord(true);
      }

      if (!barrage?.barrageVisible) {
        setMvHeight(0);
      }
    }, [barrage?.barrageVisible]);

    const onDrag = (e: any) => {
      const nowMvHeight = initBottom.current - e.clientY;
      const maxMvheight = Math.min(
        (document.body.clientHeight - 168) / 2 - 160,
        document.body.clientHeight - 168 - 200 - 160
      );
      if (e.clientY > 0 && nowMvHeight < maxMvheight && nowMvHeight > 0) {
        setMvHeight(nowMvHeight);
        barrage?.setMvHeight(nowMvHeight);
      }
    };

    const onDragStart = (event: any) => {
      // 去掉拖拽重影
      event?.dataTransfer.setDragImage(dragImg, 0, 0);
    };

    useEffect(() => {
      // getTranslateLanguage();
      barrage?.setOriginLang(originLang, false);
      barrage?.setTargetLang(targetLang, false);
    }, [originLang, targetLang]);

    if (!barrage?.barrageVisible) {
      return null;
    }
    return (
      <div className={s.barragePanel} style={{ height: minHeight + mvHeight }} id="player">
        <div
          className={s.line}
          ref={dragRef}
          onDrag={onDrag}
          onDragStart={onDragStart}
          draggable="true"
        >
          <span className={s.innerLine}></span>
        </div>

        <div className={s.content}>
          <div className={s.list}>
            <HoverIcon
              name="icon-close_1"
              title={$i('disableSubtitles')}
              className={s.close}
              onClick={handleCloseBarrage}
            ></HoverIcon>
            {connectError && <ConnectError onConnect={() => connect(true)} />}
            {!connectError && !connected && <LoadingTip />}
            {!!connected && <BarrageList list={barrageList}></BarrageList>}
          </div>

          <div className={s.bottom}>
            <LanguageSelect
              onChange={onLanguageChange}
              originLang={barrage?.originLang}
              targetLang={barrage?.targetLang}
            ></LanguageSelect>
            <FontSlider value={barrage.fontSize} onChange={onSizeChange}></FontSlider>
            {/* <PictureIcon></PictureIcon> */}
          </div>
        </div>
      </div>
    );
  })
);

export default BarragePanel;
